var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVpsIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0814 33.4236H8.87305V43.5773H12.0814V33.4236Z",
    fill: "#111733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8216 33.4236H19.6133V43.5773H22.8216V33.4236Z",
    fill: "#111733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5619 33.4236H30.3535V43.5773H33.5619V33.4236Z",
    fill: "#111733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0027 36.8958H50.1934V40.1041H55.0027V36.8958Z",
    fill: "#111733"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5208 36.8958H61.71V40.1041H66.5208V36.8958Z",
    fill: "#111733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0814 8.82593H8.87305V18.9796H12.0814V8.82593Z",
    fill: "#111733"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8216 8.82593H19.6133V18.9796H22.8216V8.82593Z",
    fill: "#111733"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5619 8.82593H30.3535V18.9796H33.5619V8.82593Z",
    fill: "#111733"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0027 12.2991H50.1934V15.5074H55.0027V12.2991Z",
    fill: "#111733"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5208 12.2991H61.71V15.5074H66.5208V12.2991Z",
    fill: "#111733"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42607 77H70.5739C74.1175 77 77 74.1175 77 70.5747V55.6203C77 53.6905 76.1275 51.9772 74.7766 50.7983C76.1275 49.6194 77 47.9065 77 45.9772V31.0228C77 29.0935 76.1275 27.3804 74.7766 26.2015C76.1275 25.0228 77 23.3095 77 21.3797V6.42528C77 2.8825 74.1175 0 70.5739 0H6.42607C2.88249 0 0 2.8825 0 6.42528V21.3797C0 23.3095 0.872578 25.0228 2.22346 26.2015C0.872578 27.3804 0 29.0935 0 31.0228V45.9772C0 47.9065 0.872578 49.6194 2.22346 50.7983C0.872578 51.9772 0 53.6905 0 55.6203V70.5747C0 74.1175 2.88249 77 6.42607 77ZM3.20833 6.42528C3.20833 4.65114 4.65114 3.20833 6.42607 3.20833H70.5739C72.3489 3.20833 73.7917 4.65114 73.7917 6.42528V21.3797C73.7917 23.1539 72.3489 24.5975 70.5739 24.5975H6.42607C4.65114 24.5975 3.20833 23.1539 3.20833 21.3797V6.42528ZM3.20833 31.0228C3.20833 29.2486 4.65114 27.8058 6.42607 27.8058H70.5739C72.3489 27.8058 73.7917 29.2486 73.7917 31.0228V45.9772C73.7917 47.7514 72.3489 49.1942 70.5739 49.1942H6.42607C4.65114 49.1942 3.20833 47.7514 3.20833 45.9772V31.0228ZM3.20833 55.6203C3.20833 53.8461 4.65114 52.4025 6.42607 52.4025H70.5739C72.3489 52.4025 73.7917 53.8461 73.7917 55.6203V70.5747C73.7917 72.3489 72.3489 73.7917 70.5739 73.7917H6.42607C4.65114 73.7917 3.20833 72.3489 3.20833 70.5747V55.6203Z",
    fill: "#111733"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0814 58.021H8.87305V68.1739H12.0814V58.021Z",
    fill: "#111733"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8216 58.021H19.6133V68.1739H22.8216V58.021Z",
    fill: "#111733"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5619 58.021H30.3535V68.1739H33.5619V58.021Z",
    fill: "#111733"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0027 61.4934H50.1934V64.7017H55.0027V61.4934Z",
    fill: "#111733"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5208 61.4934H61.71V64.7017H66.5208V61.4934Z",
    fill: "#111733"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpsIcon3);
export default __webpack_public_path__ + "static/media/vps-icon-3.d8dd5c2a4f930346422a094893bacda6.svg";
export { ForwardRef as ReactComponent };